import { sanitizeHTML } from '../functions/sanitize';

export default class Newsletter {
    constructor() {
        this.forms = [...document.querySelectorAll('.jsNewsletterForm')];

        this.forms.forEach((form) => {
            form.addEventListener('submit', (e) =>
                this.handleNewsletterSignup(e, form),
            );
        });
    }

    resetAltcha(form) {
        const widget = form.querySelector('altcha-widget');
        if (widget && typeof widget.reset === 'function') {
            widget.reset();
        }
    }

    /**
     * The invisible widget (auto="onsubmit") solves the PoW asynchronously.
     * Resolves true once the hidden `altcha` input holds a payload, false on
     * error/expiry so we can surface a message instead of posting empty.
     */
    ensureAltchaVerified(form) {
        const widget = form.querySelector('altcha-widget');
        if (!widget) {
            return Promise.resolve(true);
        }

        const tokenField = form.querySelector('input[name="altcha"]');
        if (tokenField && tokenField.value) {
            return Promise.resolve(true);
        }

        return new Promise((resolve) => {
            const onState = (ev) => {
                const state = ev.detail?.state;
                if (state === 'verified') {
                    widget.removeEventListener('statechange', onState);
                    resolve(true);
                } else if (state === 'error' || state === 'expired') {
                    widget.removeEventListener('statechange', onState);
                    resolve(false);
                }
            };

            widget.addEventListener('statechange', onState);

            if (typeof widget.verify === 'function') {
                widget.verify();
            }
        });
    }

    handleNewsletterSignup(e, form) {
        e.preventDefault();

        const submitBtn = form.querySelector('.jsNewsletterFormSubmit');
        // Message container scoped to this form (popups carry their own; the
        // section form keeps its own inside the shared form partial).
        const respContainer = form.querySelector('.jsNewsletterMessage');
        // Landing-page success dialog stays global (single instance per page).
        const respDialog = document.querySelector('.jsNewsletterDialog');
        const respDialogClose = document.querySelector(
            '.jsNewsletterDialogClose',
        );

        if (submitBtn) {
            submitBtn.setAttribute('disabled', '');
            submitBtn.classList.add('is-disabled');
        }

        this.ensureAltchaVerified(form)
            .then((verified) => {
                if (!verified) {
                    if (respContainer)
                        respContainer.innerHTML = `<p class="error">${sanitizeHTML('Weryfikacja nie powiodła się. Spróbuj ponownie.')}</p>`;

                    if (submitBtn) {
                        submitBtn.removeAttribute('disabled');
                        submitBtn.classList.remove('is-disabled');
                    }
                    this.resetAltcha(form);
                    return null;
                }

                const myFormData = new FormData(form);
                myFormData.append('security', window.global.security);

                return fetch(
                    window.global.ajax_url + '?action=addEmailToNewsletter',
                    {
                        method: 'POST',
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: myFormData,
                    },
                ).then((resp) => resp.json());
            })
            .then((data) => {
                if (!data) return;

                if (data.success) {
                    const payload = data.data;

                    if (payload?.type === 'landing' && respDialog) {
                        respDialog.insertAdjacentHTML(
                            'afterbegin',
                            sanitizeHTML(payload.msg),
                        );

                        respDialog.showModal();

                        if (respDialogClose) {
                            respDialogClose.addEventListener(
                                'click',
                                () => {
                                    respDialog.close();
                                },
                                { once: true },
                            );
                        }
                    } else if (respContainer) {
                        const msg =
                            payload && typeof payload === 'object'
                                ? payload.msg || ''
                                : payload;
                        respContainer.innerHTML = `<p class="success">${sanitizeHTML(msg)}</p>`;
                    }

                    form.reset();

                    // Let popup module react (ebook download, suppression).
                    form.dispatchEvent(
                        new CustomEvent('newsletter:success', {
                            bubbles: true,
                            detail: payload,
                        }),
                    );
                } else {
                    if (respContainer)
                        respContainer.innerHTML = `<p class="error">${sanitizeHTML(data.data)}</p>`;

                    if (submitBtn) {
                        submitBtn.removeAttribute('disabled');
                        submitBtn.classList.remove('is-disabled');
                    }
                    this.resetAltcha(form);
                }
            })
            .catch((err) => {
                console.error(err);
                this.resetAltcha(form);
            });
    }
}
